import React from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";

export default function StickyBottom({ count, total, ctaLabel, onCta, disabled, isWhatsApp = false, testId = "sticky-cta" }) {
  const { t, dir } = useI18n();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[10000] bg-white border-t border-brand-line shadow-[0_-8px_24px_rgba(42,36,33,0.06)]" dir={dir}>
      <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between gap-3 pr-3 sm:pr-4">
        <div className="leading-tight">
          <p className="font-sans text-[10px] uppercase tracking-widest text-brand-muted">
            {count} {count === 1 ? t("sticky.item") : t("sticky.items")}
          </p>
          <p className="font-serif text-2xl text-brand-dark" data-testid="sticky-total">₹{total}</p>
        </div>
        <Button
          type="button"
          onClick={onCta}
          disabled={disabled}
          data-testid={testId}
          className={`h-12 px-5 sm:px-7 rounded-full font-semibold tracking-wide disabled:opacity-40 ${
            isWhatsApp
              ? "bg-[#25D366] hover:bg-[#1FB955] text-white"
              : "bg-brand-primary hover:bg-brand-primaryHover text-brand-bone"
          }`}
        >
          {ctaLabel}
        </Button>
      </div>
    </div>
  );
}
